import axios from '../api/axiosInstance';

export const fetchShopLogins = (params = {}) => {
  return axios.get('/shop-logins', { params });
};

export const createShopLogin = (data) => {
  return axios.post('/shop-logins', data);
};

export const updateShopLogin = (id, data) => {
  return axios.patch(`/shop-logins/${id}`, data);
};
